import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

function toastErrors(erros) {
  const errors = isArray(erros) ? erros : [erros];

  errors.map((error) => {
    if (typeof error === 'string') {
      toast.error(error);
      return;
    }

    toast.error(
      error?.message ||
        error?.mensagem ||
        error?.erro ||
        error?.error ||
        t('s.geral.errogeralsistema')
    );
  });
}

export function* requestData({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'tipolocomotiva', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    toastErrors(erros);
  }
}

export function* deleteData({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `tipolocomotiva/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    toastErrors(erros);
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'tipolocomotiva', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/tiposdeequipamentosveiculo');
  } catch (erros) {
    yield put(failedRequest());
    toastErrors(erros);
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `tipolocomotiva/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    toastErrors(erros);
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'tipolocomotiva', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/tiposdeequipamentosveiculo');
  } catch (erros) {
    yield put(failedRequest());
    toastErrors(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'tipolocomotiva', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    toastErrors(erros);
  }
}

export default all([
  takeLatest('@tiposDeEquipamentosVeiculo/DATA_IN_REQUEST', requestData),
  takeLatest('@tiposDeEquipamentosVeiculo/DELETE_DATA', deleteData),
  takeLatest('@tiposDeEquipamentosVeiculo/SUCCESS_REMOVE', requestData),
  takeLatest('@tiposDeEquipamentosVeiculo/STORE_DATA', store),
  takeLatest('@tiposDeEquipamentosVeiculo/FIND_DATA', find),
  takeLatest('@tiposDeEquipamentosVeiculo/UPDATE_DATA', update),
  takeLatest('@tiposDeEquipamentosVeiculo/RECORD_FILTERING', applyedFilters),
]);
